(function () {
  'use strict';
  angular
    .module('cbl.finanza.mf.directives')
    .service('FinDossierChartPaneSrvc', function () {
      var chartDatasource = null;

      return {
        chartDatasource: chartDatasource
      };
    });
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/finDossierChartPane/finDossierChartPaneSrvc.js
 ** module id = 37
 ** module chunks = 1 2
 **/